import { render, staticRenderFns } from "./HealthrecordTimeline.vue?vue&type=template&id=0244fc69&"
import script from "./HealthrecordTimeline.vue?vue&type=script&lang=js&"
export * from "./HealthrecordTimeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports